<div class="fieldWrapper">
    <label>
        <span matTooltip="{{ metaData?.description }}">
            {{
                (metaData?.friendlyName ? metaData.friendlyName : metaData?.name) +
                    " - " +
                    (isNumber(slider.value) ? slider.value : "") +
                    " " +
                    unit
            }}
        </span>
    </label>
    <div>
        <mat-slider
            #slider
            class="range-slider"
            [min]="min"
            [max]="max"
            [step]="step"
            color="primary"
            (change)="stoppedSliding()"
            [disabled]="disabled"
        >
        </mat-slider>
        <span class="sliderValue"></span>
    </div>
    <div>
        <span class="range-style">Range: {{ min }} - {{ max }} {{ unit }}</span>
    </div>
    <div *ngIf="slider.disabled && !isLoading && enableRetry">
        <mat-button-toggle (click)="getValueEmitter.emit()">Retry</mat-button-toggle>
    </div>
    <clare-spinner *ngIf="isLoading" text="Loading Value" position="absolute" overlay="true"></clare-spinner>
</div>
